<template>
  <div class="StatusAvatar"
       :class="{
         'StatusAvatar__offline': !isOnline,
       }"
       id="StatusAvatar">
    <v-icon v-if="!isOnline"
            class="StatusAvatar__offline--icon"
            size="12px"
            color="#8898AA">mdi-sleep
    </v-icon>
    <KeybeAvatar
      :name="userName"
      :size="28"
      :img="user.photo || ''"
      :isKeybeProfile="false"
    />
  </div>
</template>

<script>
import KeybeAvatar from '@/shared/infrastructure/ui/KeybeAvatar.vue'
import { mapState } from 'vuex'
import { UserStates } from '@/components/conversations/enums/UserStates'
import { EventBus } from '@/eventBus'
import PushNotificationsController from '@/controllers/PushNotificationsController'
import AdvisersRepository from '@/modules/conversations/infrastructure/http/Advisers.repository'

export default {
  components: { KeybeAvatar },
  data () {
    return {
      adviserStatus: UserStates.Offline
    }
  },
  computed: {
    ...mapState('UserStore', ['user']),
    ...mapState('AppStore', ['advisers', 'selectedApp']),
    userName () {
      if (!this.user?.name) {
        return ''
      }
      if (!this.user?.lastName) {
        return this.user?.name
      }
      return `${this.user.name} ${this.user.lastName}`
    },
    isOnline () {
      return this.adviserStatus === UserStates.Online
    }
  },
  created () {
    this.adviserStatus = AdvisersRepository.getAdviserStatus(this.user.userId)
  },
  watch: {
    advisers () {
      this.adviserStatus = AdvisersRepository.getAdviserStatus(this.user.userId)
    }
  },
  methods: {
    async handleChange (value) {
      const status = value ? UserStates.Online : UserStates.Offline
      const userId = this.user.userId
      const variables = {
        userId,
        status,
        appUUID: this.selectedApp?.uuid || ''
      }
      const response = await AdvisersRepository.updateAdviser(variables)
      if (response.status) {
        const adviser = response.data.data.adviser
        this.updateAdviser(adviser)
        await PushNotificationsController.setOneSignalStatus({ active: value })
      } else {
        EventBus.$emit('toast', 'error', this.$t('errorUpdateAdviserStatus'))
      }
    }
  }

}
</script>

<style lang="scss">
.StatusAvatar {
  height: 32px;
  width: 32px;
  border: 2px solid #00ffdc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.StatusAvatar__offline {
  position: relative;
  border: 2px solid #8898AA;
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
}

.StatusAvatar__offline--icon {
  position: absolute !important;
  top: -2px;
  right: -6px;
  z-index: 1;
}
</style>
